import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
export function Guarantee() {
  return <section className="bg-cream px-4 py-6 sm:px-6" data-id="element-70" data-mp="1o3x1pk7r0m0y">
      <div className="mx-auto flex max-w-2xl gap-3 rounded-xl border border-sage/50 bg-white p-4 shadow-sm" data-id="element-71" data-mp="1o3dnoel7yhs7">
        <ShieldCheckIcon className="h-10 w-10 shrink-0 text-sage" strokeWidth={1.8} data-id="element-72" data-mp="221bwz5kono0u" />
        <div data-id="element-73" data-mp="19eqvvdeenxk3">
          <h2 className="font-heading text-base font-extrabold uppercase text-petrol sm:text-xl" data-id="element-74" data-mp="19ehege7feyq0">
            Your purchase is 100% protected
          </h2>
          <p className="mt-1 text-sm leading-snug sm:text-base" data-id="element-75" data-mp="14hh8s4ehnxzf">
            Explore CAREGIVER READY™ for 7 days. Discover the six modules, daily
            planners, routines, trackers, care notes, mobility &amp; safety
            resources, handoff tools and five professional bonuses. If the system
            isn’t right for you, contact us within 7 days for a full refund
            according to the refund terms.
          </p>
        </div>
      </div>
    </section>;
}